export interface IFactFinderAutoSuggestWrapper {
	suggestions: IFactFinderAutoSuggest[]
}

export interface IFactFinderAutoSuggest {
	attributes: IFactFinderAutoSuggestAttributes
	hitCount: number
	image: string
	name: string
	searchParams: string
	type: string
}

export interface IFactFinderAutoSuggestAttributes {
	seminarTyp: string
	deepLink: string
	id: string
	untertitel: string
}

export interface IFlapOutResultProps {
	suggestion: IFactFinderAutoSuggest
	searchQuery: string
}

export enum EAutoSuggestType {
	"productName",
	"category",
	"searchTerm"
}
